import React, { memo, useEffect } from "react";
import { useParams } from "react-router-dom";
import { PageTemplate } from "../../components/templates";
import { Stack } from "investira.react.components";
import useKickBack from "../../hooks/useKickBack";
import withMessage from "../../hoc/withMessage";

const PortfoliosEdit = memo((props) => {
  const params = useParams();
  const kick = useKickBack();

  useEffect(() => {
    kick && props.onMessage("Entidade alterada");
  }, [kick]);

  return (
    <PageTemplate title="Carteira" maxWidth={false}>
      <Stack spacing={2}>EDIT</Stack>
    </PageTemplate>
  );
});

PortfoliosEdit.displayName = "PortfoliosEdit";

export default withMessage(PortfoliosEdit);
